const bixSizes = ['l', 'xl', 'xxl'];
const bigSizeNumber = 24;
const bigSizeSpace = 300;
export const getStrokeWidth = (size, strokeWidth, bold) => {
  let result = 1.0;

  if (strokeWidth) {
    result = strokeWidth;
  } else if (typeof size === 'string') {
    if (size.endsWith('px')) {
      result = parseInt(size, 10) >= bigSizeNumber ? 1.5 : 1;
    } else {
      result = bixSizes.includes(size) || size.startsWith('space') && parseInt(size.substring(6), 10) >= bigSizeSpace ? 1.5 : 1;
    }
  } else {
    result = size >= bigSizeNumber ? 1.5 : 1;
  }

  return result * (bold ? 2 : 1);
};
export const choiceIconByType = (type, Outline, Fill, Duotone) => {
  switch (type) {
    case 'duotone':
      return Duotone;

    case 'fill':
      return Fill;

    default:
      return Outline;
  }
};